// Get subscription revenue data by month
export const getSubscriptionRevenue = (subscriptions: any[]) => {
  if (!subscriptions?.length) {
    return [];
  }

  // Create a map of months to track subscription revenue
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const revenueByMonth: Record<string, { amount: number, count: number }> = {};
  
  // Get the actual months that have data
  const monthsWithData = new Set<string>();
  
  // Calculate subscription revenue by month
  subscriptions.forEach(subscription => {
    if (subscription?.created_at && subscription?.status === 'active') {
      const subDate = new Date(subscription.created_at);
      const monthName = months[subDate.getMonth()];
      
      if (!revenueByMonth[monthName]) {
        revenueByMonth[monthName] = { amount: 0, count: 0 };
      }
      
      // Parse plan_price with null safety and validation
      const price = parseFloat(subscription.plan_price) || 0;
      revenueByMonth[monthName].amount += price;
      revenueByMonth[monthName].count += 1;
      monthsWithData.add(monthName);
    }
  });
  
  // Only return months that have actual data
  return Array.from(monthsWithData)
    .map(month => ({
      month,
      amount: Number((revenueByMonth[month]?.amount || 0).toFixed(2)),
      count: revenueByMonth[month]?.count || 0,
    }))
    .sort((a, b) => months.indexOf(a.month) - months.indexOf(b.month));
};